<div class="content-wrapper-inner relative">
  <app-disabled-section-widget [service]="'ntc'" (changeState)="testingDisabled = !$event.service"></app-disabled-section-widget>
  <div *ngIf="testingDisabled === false">
    <div class="create-test-section border">
      <app-lnt-form
        (onAfterSave)="afterSave($event)"
        [pauseUpdate]="pauseUpdateForm"
        [hiddenSearchButton]="collapseSearch"
        (onClickSearchButton)="onCollapseSearch()"></app-lnt-form>
    </div>
    <app-lnt-search-form (onSubmit)="onSubmitFilter($event)" (onHide)="onCollapseSearch($event)"></app-lnt-search-form>
    <div>
      <app-lnt-results-table
        [pauseUpdate]="pauseUpdateResults"
        (repeat)="onRepeat($event)"
        (changeBatch)="selectedRows.set($event)"></app-lnt-results-table>
      <div class="table-action-info-bar" *ngIf="selectedRows().length">
        <div class="info-left">
          <div class="text-icon-holder" (click)="batchClear()" tabindex="0" (keyup.enter)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{ selectedRows().length }} Selected</span>
          </div>
        </div>
        <div class="info-right">
          <div class="text-icon-holder" (click)="onBatchRepeat()" tabindex="0" (keyup.enter)="onBatchRepeat()">
            <span class="icon">
              <span class="icon-refresh"></span>
            </span>
            <span class="text">Repeat</span>
          </div>
          <button [disabled]="!hasReimbursableTests()" class="btn ghost-btn btn-action text-icon-holder" (click)="onBatchReimburse()" *ngIf="isAdmin">
            <span class="icon">
              <span class="far fa-money-bill-alt fs-4"></span>
            </span>
            <span class="text ms-0_5">Reimburse</span>
          </button>
          <button
            [tooltip]="shareTestTooltip()"
            [options]="{ offset: [0, 15] }"
            [tooltipPlacement]="'top'"
            [disabled]="this.selectedRows().length === 0 || hasForbiddenTestsToShare()"
            class="btn ghost-btn btn-action text-icon-holder"
            (click)="onShareTestsClick()">
            <span class="icon">
              <i class="icon-link"></i>
            </span>
            <span class="text ms-0_5">Share</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #batchRepeatModal let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title d-flex align-items-center justify-content-between">
      <h3 class="d-inline-block">Batch Repeat ({{ selectedRows().length }} tests)</h3>
      <div>
        <button class="btn ms-15" type="button" (click)="dialogRef.close(true)">
          <span class="icon-close"></span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body mb-10">
    <div *ngIf="isBatchRepeatLoading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <app-lnt-results-table [pauseUpdate]="true" [compact]="true" [batchRepeatRows]="selectedRows()"></app-lnt-results-table>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <div>
        <b class="me-10">{{ this.selectedRows().length }} tests for &euro; {{ this.testsPrice }}</b>
        <button class="btn btn-primary" (click)="onRepeatClick()"><span class="icon-refresh"></span> Repeat</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #reimburseModalTpl let-dialogRef="dialogRef">
  <confirm-modal [dialogRef]="dialogRef"></confirm-modal>
</ng-template>

<ng-template #shareTestsModalTpl let-dialogRef="dialogRef">
  <app-share-test-results-modal [shareTestResultsInfo]="shareTestResultsInfo()" [dialogRef]="dialogRef"></app-share-test-results-modal>
</ng-template>
